import React, { useState } from 'react';
import 'moment/locale/pt';
import { Box, Button, FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { enqueueSnackbar } from 'notistack';
import { PutFetch } from '../../../../../services/apiBase';

export default function EditModal({ agreement, setTradeAgreementToEdit, onClose, getList }) {

  const [load, setLoad] = useState(false);

  const handleEditValues = async (e) => {
    const key = e.target.id
    const value = e.target.value
    console.log('VALUE: ', key)
    setTradeAgreementToEdit({...agreement, [key]: value })
  }

  const handleOnCloseModal = () => {
    onClose()
  }

  const handleSalveEditedValues = async (e) => {
    try {
      setLoad(true)
      const response = await PutFetch(`/financial/updateTradeAgreement?id=${agreement.id}`, agreement);
      getList()
      handleOnCloseModal()
      enqueueSnackbar('Alteração salva com sucesso!', { variant: 'success' });
      
      setLoad(false)
    return
    } catch (error) {
     console.log(error)
     setLoad(false)
    }
  }

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Cadastrar nova política
        </Typography>
      </Box>

      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 400,
        minWidth: 400,
        maxHeight: '80%',
        height: '90%',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 2
      }}>
        <FormControl fullWidth>
          <TextField
            id={`amount_start`}
            label="Valor inicial"
            type="number"
            value={agreement.amount_start}
            onChange={(event) => {
              handleEditValues(event);
            }}
          />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            id={`amount_end`}
            label="Valor final"
            type="number"
            value={agreement.amount_end}
            onChange={(event) => {
              handleEditValues(event);
            }}
          />
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="rate">Taxa</InputLabel>
          <OutlinedInput
            id={`rate`}
            endAdornment={<InputAdornment position="end">%</InputAdornment>}
            label="Taxa"
            value={agreement.rate}
            onChange={(event) => {
              handleEditValues(event);
            }}
          />
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="is_actived">Selecione o status</InputLabel>
          <Select
            labelId="is_actived"
            id="is_actived"
            name="is_actived" 
            label="Selecione o status"
            value={agreement.is_actived}
            onChange={event => {
              setTradeAgreementToEdit({...agreement, ['is_actived']: event.target.value })
            }}
          >
            <MenuItem value={true}>Ativado</MenuItem>
            <MenuItem value={false}>Desativado</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color={'success'}>
          <Typography color={'#fff'} onClick={() => handleSalveEditedValues()}>
            Salvar
          </Typography>
        </Button>
        <Button variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
